import { createAction, handleActions } from 'redux-actions';
import api from '../../api';

const initialState = {
	isAuthenticated: false,
	loginFailed: false,
	fetching: false,
	error: null,
};

// ------------------------------------
// Constants
// ------------------------------------
export const SESSION_CREATE = 'SESSION_CREATE';
export const SESSION_CREATE_SUCCESS = 'SESSION_CREATE_SUCCESS';
export const SESSION_CREATE_PENDING = 'SESSION_CREATE_PENDING';
export const SESSION_CREATE_FAILURE = 'SESSION_CREATE_FAILURE';
export const SESSION_DESTROY = 'SESSION_DESTROY';
export const SESSION_RESET = 'SESSION_RESET';

// ------------------------------------
// Actions
// ------------------------------------
const createSession = createAction(SESSION_CREATE, (username, password, redirectAfterLogin = null) => {
	return ({
		promise: api.createSession(username, password, redirectAfterLogin),
	});
});

const destroySession = createAction(SESSION_DESTROY, logoutUrl => ({
	promise: api.destroySession(logoutUrl),
}));

const resetSession = createAction(SESSION_RESET);

export const actions = {
	createSession,
	destroySession,
	resetSession,
};

// ------------------------------------
// Reducer
// ------------------------------------
export default handleActions({
	[SESSION_CREATE]: (state) => {
		return Object.assign({}, state, {
			isAuthenticated: false,
			fetching: true,
			loginFailed: false,
		});
	},
	[SESSION_RESET]: (state) => {
		return Object.assign({}, state, initialState);
	},
	[SESSION_CREATE_PENDING]: (state) => {
		return Object.assign({}, state, {
			isAuthenticated: false,
			fetching: true,
			loginFailed: false,
		});
	},
	[SESSION_CREATE_SUCCESS]: (state) => {
		return Object.assign({}, state, {
			isAuthenticated: true,
			loginFailed: false,
			fetching: false,
			error: null,
		});
	},
	[SESSION_CREATE_FAILURE]: (state, { payload }) => {
		return Object.assign({}, state, {
			isAuthenticated: false,
			loginFailed: true,
			fetching: false,
			error: JSON.parse(payload.message),
		});
	},
}, initialState);



// WEBPACK FOOTER //
// ./src/redux/modules/session.js